module.exports = __webpack_public_path__ + "img/Stylo.71ce295f.svg";